import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultRichTextField, defaultField, defaultPercentField } from "helpers/row-logic-helper";
import { get } from "lodash";

import { shouldShowField } from "../loanDetailEditUtil";

import {
  lendersMapNestedRows
  , shouldShowSpreadReductionTerms
  , shouldShowServicerCompany
  , shouldShowLoanReferenceNumber
  , shouldShowCounterparty
  , shouldShowLoanSeniority
  , shouldShowLoanStatus
  , shouldShowLoanType
  , shouldShowDefaultInterestSpread
  , shouldShowRecurringCosts
  , shouldShowCollateralization
  , shouldShowLoanField
  , shouldShowRateReductionTerms
} from "./section-loan-misc-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  lenders: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Lender(s)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT_NESTED,
        mapNestedRows: data => lendersMapNestedRows(data),
        map: data => defaultField(data, "name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [
          { map: row => get(row, "lenderType") },
          { map: row => get(row, "allocated") },
          { map: row => get(row, "companyContact") },
          { map: row => get(row, "isLead") }]
      }
    ]
  },
  lendersCounsel: {
    isVisible: data => shouldShowField(data, "details.lenderCounselCompanyId"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Lenders Counsel",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "details.lenderCounselCompany.name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [{ map: data => defaultField(data, "details.lendersCounselContact.fullName") }]
      }
    ]
  },
  servicerCompany: {
    isVisible: data => shouldShowServicerCompany(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Servicer",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "details.servicerCompany.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  loanReferenceNumber: {
    isVisible: data => shouldShowLoanReferenceNumber(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Loan Reference Number",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "details.loanReferenceNumber"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  borrower: {
    isVisible: data => shouldShowCounterparty(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Borrower",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "details.counterparty"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  borrowersCounsel: {
    isVisible: data => shouldShowField(data, "details.borrowerCounselCompanyId"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Borrowers Counsel",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "details.borrowerCounselCompany.name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [{ map: data => defaultField(data, "details.borrowerCounselContact.fullName") }]
      }
    ]
  },
  titleCompany: {
    isVisible: data => shouldShowField(data, "details.titleCompanyId"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Title Company",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "details.titleCompany.name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [{ map: data => defaultField(data, "details.titleCompanyContact.fullName") }]
      }
    ]
  },
  loanSeniority: {
    isVisible: data => shouldShowLoanSeniority(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Loan Seniority",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "details.loanSeniority.value"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  lienPriority: {
    isVisible: data => shouldShowField(data, "details.lienPriority"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Lien Priority",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "details.lienPriority"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  loanStatus: {
    isVisible: data => shouldShowLoanStatus(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Loan Status",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "details.loanStatus.value"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  loanType: {
    isVisible: data => shouldShowLoanType(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Loan Type",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "details.loanType.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  rateReductionTerms: {
    isVisible: loan => shouldShowField(loan, "details.rateReductionTerms") && shouldShowRateReductionTerms(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Rate Reduction Terms",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "details.rateReductionTerms"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  defaultInterestSpread: {
    isVisible: data => shouldShowDefaultInterestSpread(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Default Interest Spread",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: data => defaultPercentField(data, "details.defaultInterestSpread", 100),
        Cell: tableSideColumnMapper,
        decimals: 3
      }
    ]
  },
  recurringCosts: {
    isVisible: data => shouldShowRecurringCosts(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Recurring Costs",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "details.recurringCosts"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  additionalInterest: {
    isVisible: data => shouldShowField(data, "details.additionalInterest"),
    label: "Additional Interest",
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Additional Interest",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "details.additionalInterest"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  collateralization: {
    isVisible: data => shouldShowCollateralization(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Collateralization",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "details.collateralization"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  loanRiskRating: {
    isVisible: data => shouldShowLoanField(data, "details.loanRiskRating.name"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Loan Risk Rating",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "details.loanRiskRating.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  footnote: {
    isVisible: data => shouldShowField(data, "details.footnote"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Footnotes",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultRichTextField(data, "details.footnote"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
